export const LAZY_LOAD_ACTIONS = {
  SET_DATA: "LAZY_LOAD/SET_DATA",
  REMOVE_ROW: "LAZY_LOAD/REMOVE_ROW",
  UPDATE_ROW: "LAZY_LOAD/UPDATE_ROW",
};

const updateErrorThunk = (error: any, entity: string) => {
  return async (dispatch: any) => {
    console.error(error);
    dispatch(
      setDataForLazyLoadedContent({ entity, data: { loading: false, error } })
    );
  };
};

export const setDataForLazyLoadedContent = ({
  entity,
  data,
}: {
  entity: string;
  data: any;
}) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: LAZY_LOAD_ACTIONS.SET_DATA,
        payload: {
          entity,
          data,
        },
      });
    } catch (error) {}
  };
};

export const removeTableRow = ({
  entity,
  rowId,
}: {
  entity: string;
  rowId: string;
}) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: LAZY_LOAD_ACTIONS.REMOVE_ROW,
        payload: {
          entity: entity,
          rowId: rowId,
        },
      });
    } catch (error) {
      dispatch(updateErrorThunk(error, entity));
    }
  };
};

export const updateDetailsOfConversation = (payload: {
  conversationId: string;
  data: any;
  entity: string;
}) => {
  return async (dispatch: any) => {
    dispatch({
      type: LAZY_LOAD_ACTIONS.UPDATE_ROW,
      payload: payload,
    });
  };
};
